module.exports = __webpack_public_path__ + "static/media/newskyline-tour-3.b904d2b1.jpg";